import React from 'react';
import './Expert.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import { BsFillCheckCircleFill } from "react-icons/bs";
import expertImg from '../../assets/expert.png';

const Expert = () => {
    return (
        <section className='expert-section' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6">
                        <div className="expert-text">
                            <SectionTitle 
                                subTitle="DİŞ HEKİMLİĞİNDE UZMANLIK"
                                title="Deneyimli hekimlerden üst düzey ağız ve diş sağlığı hizmeti"
                                description="Tedavilerimizi güncel teknoloji, şeffaf iletişim ve hasta konforu odağında planlıyoruz."
                            />

                            <ul>
                                <li>
                                    <BsFillCheckCircleFill />
                                    Alanında deneyimli diş hekimi kadrosu
                                </li>
                                <li>
                                    <BsFillCheckCircleFill />
                                    Modern teknolojiyle desteklenen tedaviler
                                </li>
                                <li>
                                    <BsFillCheckCircleFill />
                                    Uygun fiyatlı ve planlı tedavi seçenekleri
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <div className="expert-img">
                            <img src={expertImg} alt="uzman diş hekimi" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Expert;